import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CreditCard, Mail, PlayCircle, Users } from 'lucide-react';
import { CTAButton } from './shared/CTAButton';
import { CountdownTimer } from './shared/CountdownTimer';
export function Pricing() {
  return <section className="py-20 bg-white relative overflow-hidden" data-id="element-133">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-[#F5E6E0]/40 via-transparent to-transparent" data-id="element-134" />

      <div className="max-w-5xl mx-auto px-4 relative z-10" data-id="element-135">
        {/* How it works */}
        <div className="mb-20" data-id="element-136">
          <h2 className="text-3xl font-serif text-center mb-12 text-[#1A1A2E]" data-id="element-137">
            ¿Cómo funciona?
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-138">
            {[{
            icon: <CreditCard data-id="element-139" />,
            title: '1. Pago seguro',
            desc: 'Plataforma verificada'
          }, {
            icon: <Mail data-id="element-140" />,
            title: '2. Acceso email',
            desc: 'Automático'
          }, {
            icon: <PlayCircle data-id="element-141" />,
            title: '3. Plataforma',
            desc: 'Empezás ya'
          }, {
            icon: <Users data-id="element-142" />,
            title: '4. Grupo',
            desc: 'Consultás dudas'
          }].map((step, idx) => <div key={idx} className="flex flex-col items-center text-center" data-id="element-143">
                <div className="w-16 h-16 bg-[#FFF8F0] rounded-full flex items-center justify-center text-[#9B2C5E] mb-4 border border-[#C9A96E]/30" data-id="element-144">
                  {step.icon}
                </div>
                <h3 className="font-bold text-[#1A1A2E]" data-id="element-145">{step.title}</h3>
                <p className="text-sm text-gray-500" data-id="element-146">{step.desc}</p>
              </div>)}
          </div>
        </div>

        {/* Pricing Card */}
        <motion.div id="pricing-cta" initial={{
        scale: 0.95,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-2xl shadow-rose-900/10 border border-[#F5E6E0] overflow-hidden max-w-3xl mx-auto" data-id="element-147">
          <div className="bg-[#1A1A2E] text-white p-4 text-center" data-id="element-148">
            <p className="text-[#C9A96E] font-bold tracking-widest uppercase text-sm" data-id="element-149">
              Oferta Especial
            </p>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-150">
            <h3 className="text-2xl md:text-3xl font-serif text-[#1A1A2E] mb-2" data-id="element-151">
              Accedé hoy por un único pago
            </h3>
            <p className="text-gray-500 mb-8" data-id="element-152">
              No hay mensualidades. Es tuyo para siempre.
            </p>

            <div className="flex items-center justify-center gap-4 mb-8" data-id="element-153">
              <span className="text-2xl text-gray-400 line-through decoration-red-400" data-id="element-154">
                $99.99 USD
              </span>
              <span className="text-5xl md:text-6xl font-bold text-[#9B2C5E]" data-id="element-155">
                $29
              </span>
              <span className="text-xl text-gray-600 self-end mb-2" data-id="element-156">USD</span>
            </div>

            <div className="mb-10" data-id="element-157">
              <CTAButton text="ACCEDER AHORA POR $29 USD" fullWidth className="max-w-md mx-auto py-5 text-xl" data-id="element-158" />
              <p className="text-xs text-gray-400 mt-3" data-id="element-159">
                *Pago seguro · Acceso inmediato · Garantía 7 días
              </p>
            </div>

            {/* Urgency */}
            <div className="bg-[#FFF8F0] rounded-xl p-6 border border-[#C9A96E]/20" data-id="element-160">
              <p className="text-[#9B2C5E] font-bold mb-4" data-id="element-161">
                El precio promocional termina en:
              </p>
              <CountdownTimer data-id="element-162" />
              <p className="text-sm text-gray-600 mt-4 italic" data-id="element-163">
                Cuando el contador llegue a cero, el programa vuelve a precio
                regular automáticamente.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Guarantee */}
        <div className="mt-16 flex flex-col md:flex-row items-center justify-center gap-6 max-w-2xl mx-auto bg-[#F5E6E0]/30 p-6 rounded-2xl border border-[#F5E6E0]" data-id="element-164">
          <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center text-[#C9A96E] shrink-0 shadow-sm" data-id="element-165">
            <ShieldCheck className="w-10 h-10" data-id="element-166" />
          </div>
          <div className="text-center md:text-left" data-id="element-167">
            <h4 className="text-xl font-bold text-[#1A1A2E] mb-2" data-id="element-168">
              Garantía de 7 días
            </h4>
            <p className="text-gray-600" data-id="element-169">
              Probalo sin riesgo. Si no es para vos, podés solicitar el
              reembolso dentro de los 7 días.
            </p>
          </div>
        </div>
      </div>
    </section>;
}